mpangoApp.factory('Mvendor',['$http', function ($http) {
	return{
		getVendors : function  () {
			return $http.get('index.php/api/getvendors');
		},
		postVendor : function(vendor) {
			return $http({
				method: 'POST',
				url: 'index.php/api/postvendor',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':vendor}
			
			});
		},
		updateVendor : function(vendordata,formname) {
			return $http({
				method: 'POST',
				url: 'index.php/api/updatevendor',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':vendordata,'formname':formname}
			});
		},
	}
}]);